import { InjectionToken } from '@angular/core';

import type { IThirdPartyService } from './third-party.models';

export const ThirdPartyService = new InjectionToken<IThirdPartyService>('ThirdPartyService');
